import { SVGProps } from "react";

export default function SearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12.5001 10.9999H11.7101L11.4301 10.7299C12.6301 9.32989 13.2501 7.41989 12.9101 5.38989C12.4401 2.60989 10.1201 0.389893 7.32014 0.0498932C3.09014 -0.470107 -0.469863 3.08989 0.0501373 7.31989C0.390137 10.1199 2.61014 12.4399 5.39014 12.9099C7.42014 13.2499 9.33014 12.6299 10.7301 11.4299L11.0001 11.7099V12.4999L15.2501 16.7499C15.6601 17.1599 16.3301 17.1599 16.7401 16.7499C17.1501 16.3399 17.1501 15.6699 16.7401 15.2599L12.5001 10.9999ZM6.50014 10.9999C4.01014 10.9999 2.00014 8.98989 2.00014 6.49989C2.00014 4.00989 4.01014 1.99989 6.50014 1.99989C8.99014 1.99989 11.0001 4.00989 11.0001 6.49989C11.0001 8.98989 8.99014 10.9999 6.50014 10.9999Z" />
    </svg>
  );
}
